import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssignDevicesOptions from './AssignDevicesOptions';
import AssignDevicesMain from './AssignDevicesMain';

function AssignDevices(props) {
  
    return (
      <React.Fragment>
        <Routes>
          <Route
            path="/"
            element={<AssignDevicesMain />}
            data-test="assignDevices-route"
          />
          <Route
            path="/options"
            element={<AssignDevicesOptions />}
            data-test="assignDevicesOption-route"
          />
        </Routes>
      </React.Fragment>
    );
  }
  export const AssignDevicesWithRouter = AssignDevices;
  export default AssignDevices;